import { useState } from 'react';

export const useChatState = (initialPage = 'default') => {
  const [page, setPage] = useState(initialPage);
  const [chat, setChat] = useState(null);
  const [typeAction, setTypeAction] = useState('create');
  const [params, setParams] = useState({});
  const changePage = (newPage, newChat = null, newTypeAction = 'create', newParams = {}) => {
    setPage(newPage);
    setChat(newChat);
    setTypeAction(newTypeAction);
    setParams(newParams);
  };

  return {
    page,
    chat,
    typeAction,
    setPage,
    setChat,
    setTypeAction,
    changePage,
    params
  };
};
